import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSeekedVideo.meta';

export type TrackSeekedVideoParams = {
  duration: number;
  id: string;
  timeFormat: 'standard' | 'frames' | 'timecode';
  type: 'forward' | 'backward';
};

export const useTrackSeekedVideo = () => {
  const { track } = useAnalyticsUtilities();

  const trackSeekedVideo = useCallback(
    (params: TrackSeekedVideoParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSeekedVideo };
};
